import { render, staticRenderFns } from "./Landingpages.vue?vue&type=template&id=c1784a56&"
import script from "./Landingpages.vue?vue&type=script&lang=js&"
export * from "./Landingpages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports